import React, { createContext, useContext, useState } from 'react'


const LoadingContext = createContext()


export const LoadingPermissionProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)


  const startLoading = () => setLoading(true)
  const stopLoading = () => setLoading(false)

  return (
    <LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}


export const useLoadingPermision = () => useContext(LoadingContext)
